module.exports = __webpack_public_path__ + "static/media/star7.6ff858e8.svg";